import ReportSubsection from "@app/analytics/components/reports/ReportSubsection";

import { Column } from "@rui/Stack";

import FillerWordsModule from "./FillerWordsModule";
import {
  Section,
  SectionHeading,
  SectionSubtitle,
  SectionTitle,
} from "./styles";
import TalkingPaceModule from "./TalkingPaceModule";
import type { CoachingSectionProps } from "./types";

const CoachingClarity = ({
  onClickMoment,
  onClickWord,
}: CoachingSectionProps) => {
  return (
    <ReportSubsection id="clarity" sx={{ p: 0, pb: 1 }}>
      <Section>
        <SectionHeading>
          <SectionTitle>Clarity</SectionTitle>
          <SectionSubtitle>
            Measures how coherent your speech is
          </SectionSubtitle>
        </SectionHeading>
        <Column>
          <TalkingPaceModule onClickMoment={onClickMoment} />
          <FillerWordsModule
            onClickMoment={onClickMoment}
            onClickWord={onClickWord}
          />
        </Column>
      </Section>
    </ReportSubsection>
  );
};

export default CoachingClarity;
